(function () {

  function getPositions(variantId) {
    if (!window.variantImageMap || !window.productMediaCount) return null;

    const currentPosition = window.variantImageMap[variantId];
    if (!currentPosition) return null;

    const positions = Object.values(window.variantImageMap)
      .filter((p) => p > 0)
      .sort((a, b) => a - b);

    let nextPosition = window.productMediaCount + 1;

    for (let i = 0; i < positions.length; i++) {
      if (positions[i] > currentPosition) {
        nextPosition = positions[i];
        break;
      }
    }

    return { currentPosition, nextPosition };
  }

  function isMobileView() {
    return window.matchMedia("(max-width: 749px)").matches;
  }

  function updateVariantImages(variantId) {
    const data = getPositions(variantId);
    if (!data) return;

    const { currentPosition, nextPosition } = data;

    // =========================
    // DESKTOP GRID (SAFE)
    // =========================
    document.querySelectorAll(".product-media-item").forEach((item) => {
      const pos = parseInt(item.dataset.mediaPosition);

      if (pos >= currentPosition && pos < nextPosition) {
        item.classList.remove("is-hidden");
      } else {
        item.classList.add("is-hidden");
      }
    });

    // =========================
    // MOBILE SLIDER (IMPORTANT)
    // =========================
    if (isMobileView()) {
setTimeout(() => {
  const slideshow = document.querySelector("slideshow-component");
  if (!slideshow) return;

  const scroller = slideshow.querySelector('[ref="scroller"]');
  if (!scroller) return;

  const slides = slideshow.querySelectorAll("slideshow-slide");

  let targetIndex = -1;

  slides.forEach((slide, index) => {
    const inner = slide.querySelector(".js-slide-inner");
    if (!inner) return;

    const pos = parseInt(inner.dataset.mediaPosition);

    if (pos === currentPosition) {
      targetIndex = index;
    }
  });

  // safety fallback
  if (targetIndex === -1) {
    console.warn("Slide not found → fallback to 0");
    targetIndex = 0;
  }

  const slideWidth = slides[0]?.offsetWidth || 0;

  scroller.scrollTo({
    left: slideWidth * targetIndex,
    behavior: "auto"
  });

}, 120);
    }
  }

  // =========================
  // EVENTS
  // =========================

  document.addEventListener("variant:change", function (event) {
    const variant = event.detail?.variant;
    if (!variant) return;

    setTimeout(() => {
      updateVariantImages(variant.id);
    }, 80);
  });

  document.addEventListener("change", function (e) {
    if (e.target && e.target.name === "id") {
      const variantId = e.target.value;

      setTimeout(() => {
        updateVariantImages(variantId);
      }, 80);
    }
  });

  document.addEventListener("DOMContentLoaded", function () {
    const variantInput = document.querySelector("[name='id']");
    if (!variantInput) return;

    setTimeout(() => {
      updateVariantImages(variantInput.value);
    }, 100);
  });

  // URL change fallback
  let lastUrl = location.href;

  setInterval(() => {
    if (location.href !== lastUrl) {
      lastUrl = location.href;

      const urlParams = new URLSearchParams(window.location.search);
      const variantId = urlParams.get("variant");

      if (variantId) {
        setTimeout(() => {
          updateVariantImages(variantId);
        }, 120);
      }
    }
  }, 500);

})();
